import React, { Dispatch } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons/lib/icons';
import { FormInstance, Space } from 'antd';
import styled from 'styled-components';

import { PricingRoutes, SearchContracts } from 'pricing/types';
import { ContractListRouteParams } from 'pricing/pages/contractList/ContractList';
import { ContractListingAction } from 'pricing/pages/contractList/ContractList.state';
import { testId } from 'pricing/utilities/test/dataTestId';
import { toPluralOrSingular } from 'utilities/text/text';

const ContractListTitleContent = styled.div`
  font-weight: normal;
`;

interface ContractTitleProps {
  resultsCounts?: number;
  dispatch: Dispatch<ContractListingAction>;
  form?: FormInstance;
}

function ContractListFiltersTitle({ resultsCounts, dispatch, form }: ContractTitleProps) {
  const { category, query }: ContractListRouteParams = useParams();
  const history = useHistory();

  const goBack = () => {
    form?.resetFields();
    history.push(PricingRoutes.ContractList);
    dispatch({
      type: 'FILTER_CONTRACTS',
      payload: {},
    });
    dispatch({ type: 'EXPAND_ALL_CONTRACTS', payload: false });
  };

  const getContractLabel = (contract: SearchContracts) => {
    const { ContractId, BreederId, BreederName } = SearchContracts;
    switch (contract) {
      case BreederName:
        return 'Breeder name';
      case BreederId:
        return 'Breeder ID';
      case ContractId:
        return 'Contract ID';
    }
  };

  return !category ? (
    <span data-testid={testId.contractListFilterTitle}>All Contracts</span>
  ) : (
    <Space>
      <ArrowLeftOutlined
        data-testid={testId.contractListFilterTitleGoBack}
        onClick={goBack}
      />
      <ContractListTitleContent data-testid={testId.contractListFilterTitleWithCategory}>
        {getContractLabel(category)}: <strong>{query}</strong> ({resultsCounts}&nbsp;
        {toPluralOrSingular('result', resultsCounts)})
      </ContractListTitleContent>
    </Space>
  );
}

export default ContractListFiltersTitle;
